import WorldMapInterop from "./WorldMapInterop";
import RedesignBrowserInterop from "./RedesignBrowserInterop";

const mudBlazorScript = document.createElement('script');
mudBlazorScript.src = "_content/MudBlazor/MudBlazor.min.js";

mudBlazorScript.onload = function() {
  console.log("MudBlazor Script is loaded and ready!");
};

document.body.appendChild(mudBlazorScript);

window.WorldMapInterop = document.WorldMapInterop = Element.prototype.WorldMapInterop
  = window.WorldMapInterop || document.WorldMapInterop || Element.prototype.WorldMapInterop || new WorldMapInterop();

window.RedesignBrowserInterop = document.RedesignBrowserInterop = Element.prototype.RedesignBrowserInterop
  = window.RedesignBrowserInterop || document.RedesignBrowserInterop || Element.prototype.RedesignBrowserInterop || new RedesignBrowserInterop();
